import { render, staticRenderFns } from "./app-header-user.component.vue?vue&type=template&id=1ec82e20&scoped=true"
import script from "./app-header-user.component.vue?vue&type=script&lang=ts"
export * from "./app-header-user.component.vue?vue&type=script&lang=ts"
import style0 from "./app-header-user.component.vue?vue&type=style&index=0&id=1ec82e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec82e20",
  null
  
)

export default component.exports